import { FC } from 'react';
import { IconProps, defaultIconProps } from './IconProps';

export const IconShield: FC<IconProps> = ({ size, color, strokeWidth, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path
      d="M9.41899 18.0122C9.60349 18.1198 9.69573 18.1737 9.82592 18.2016C9.92695 18.2232 10.0744 18.2232 10.1754 18.2016C10.3056 18.1737 10.3978 18.1198 10.5823 18.0122C12.2057 17.0651 16.6673 14.0902 16.6673 9.99981V6.01448C16.6673 5.34822 16.6673 5.01509 16.5584 4.72873C16.4621 4.47576 16.3057 4.25004 16.1026 4.07109C15.8727 3.86851 15.5608 3.75154 14.937 3.5176L10.4688 1.84204C10.2956 1.77707 10.2089 1.74459 10.1198 1.73171C10.0408 1.72029 9.96051 1.72029 9.88147 1.73171C9.79236 1.74459 9.70573 1.77707 9.53249 1.84204L5.06432 3.5176C4.44048 3.75154 4.12856 3.86851 3.8987 4.07109C3.69564 4.25004 3.53921 4.47576 3.44295 4.72873C3.33398 5.01509 3.33398 5.34822 3.33398 6.01448V9.99981C3.33398 14.0902 7.79562 17.0651 9.41899 18.0122Z"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

IconShield.defaultProps = defaultIconProps;
